import Vue from 'vue'
import Vuex from 'vuex'
import alert from './modules/alert'
import jssdk from './modules/jssdk'
import weui from './modules/weui'
import home from './modules/home'

import enroll from './modules/event/enroll'

// 图书购买界面
import book from './modules/store/book'

// 工具
import hookedMaker from './modules/tools/hookedMaker'

Vue.use(Vuex)

// state
const state = {
    loading: false,     // 是否显示loading
}

// mutations
const mutations = {

    /**
     * 设置是否为对话框样式
     * @param {*} state 
     * @param {*} groupedStyle 
     */
    dialog: function (state, dialogStyle = true) {
        if (typeof (dialogStyle) == 'string') {
            document.querySelector('body').setAttribute('style', 'background-color:' + dialogStyle);
            return;
        }

        if (dialogStyle) {
            document.querySelector('body').setAttribute('style', 'background-color:#f8f8f8');
        } else {
            document.querySelector('body').removeAttribute('style');
        }
    },
    loading: function (state, loading = true) {
        state.loading = loading;
    }
}

export default new Vuex.Store({
    modules: {
        alert,
        home,
        jssdk,
        weui,
        enroll,
        book,
        hookedMaker
    },
    state,
    mutations,
    strict: process.env.NODE_ENV !== 'production',
})